/* eslint-disable no-unused-vars */
import { CurrentTimeInfo } from "@lhd/types";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import { BUTTONS_ACTION, LOG_TYPE } from "../contants";
import ButtonAction from "./ButtonAction";
import Clock from "./Clock";
import { Tooltip } from "antd";
import { useFetchWorkerLogTimes } from "@lhd/hooks";
import { useState } from "react";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";

dayjs.locale("ja");

type CurrentTimeQueryData = {
  data?: CurrentTimeInfo;
  datetimeWithTimeRes?: Date;
};
interface IProps {
  className?: string;
  currentTimeData?: CurrentTimeQueryData;
  serverNowMs?: number;
  disableBtns?: {
    [key in LOG_TYPE]?: boolean;
  };
  onCheckIn: (logType: LOG_TYPE) => void;
}

const AttendancePanel = (props: IProps) => {
  const { currentTimeData, serverNowMs, disableBtns, onCheckIn } = props;
  const [isShowRecheckinPopup, setIsShowRecheckinPopup] = useState(false);
  const {
    data,
    isLoading: isLoadingFetchLogTimes,
    isFetching,
    isSuccess,
    refetch: refetchWorkerLogtimes,
  } = useFetchWorkerLogTimes();

  const lastCheckoutAt = data?.data?.today_logs
    ?.filter((log) => log.log_type === LOG_TYPE.CHECKOUT)
    .at(-1)?.logged_at;
  const lastCheckoutTime = lastCheckoutAt
    ? dayjs(lastCheckoutAt).format("HH:mm")
    : "--:--";
  const recheckinTime = dayjs(serverNowMs ?? Date.now()).format("HH:mm");

  return (
    <div className="attendance-panel-wrapper">
      <div className="d-flex flex-col align-items-center justify-content-center">
        <span className="current-date">
          {dayjs(currentTimeData?.data?.current_date).format(
            "YYYY年M月D日 （dd）",
          )}
        </span>
        <Clock serverNowMs={serverNowMs} />
      </div>

      <div className="container_button_action_and_list">
        <div className="container_button_action">
          {BUTTONS_ACTION.map((button) => {
            const keyOfDisableBtns =
              button.log_type as keyof typeof disableBtns;
            const isOther = button.log_type === LOG_TYPE.OTHER;

            const buttonNode = (
              <ButtonAction
                className={isOther ? "other-btn" : undefined}
                disabled={disableBtns && !!disableBtns[keyOfDisableBtns]}
                key={button.label}
                style={button.style}
                onClick={() => {
                  if (
                    button.log_type === LOG_TYPE.CHECKIN &&
                    data?.data?.can_recheckin
                  ) {
                    setIsShowRecheckinPopup(true);
                    return;
                  }
                  onCheckIn(button.log_type);
                }}
              >
                <span>{button.label}</span>
                {button?.icon}
              </ButtonAction>
            );

            return isOther ? (
              <Tooltip key={button.label} title="開発中" color="#6BC77A">
                <div className="orther-btn-container">{buttonNode}</div>
              </Tooltip>
            ) : (
              buttonNode
            );
          })}
        </div>
      </div>
      <ModalConfirm
        isOpen={isShowRecheckinPopup}
        content={
          <div>
            <strong>再度の出勤打刻</strong>
            <div style={{ textAlign: "left" }}>
              <br />
              本日はすでに退勤（{lastCheckoutTime}）を記録済みです。
              <br />
              出勤を打刻すると、前回の退勤時刻（{lastCheckoutTime}
              ）が休憩開始時刻として記録され、今回の打刻時刻（{recheckinTime}
              ）が休憩終了時刻となります。退勤は未入力に戻ります。
              <br />
              よろしいですか？
            </div>
          </div>
        }
        cancelText="キャンセル"
        okText="出勤する"
        onOk={() => {
          setIsShowRecheckinPopup(false);
          onCheckIn(LOG_TYPE.CHECKIN);
        }}
        onCancel={() => setIsShowRecheckinPopup(false)}
      />
    </div>
  );
};

export default AttendancePanel;
